/**
 * Ранний boot до загрузки i18n: префикс /ru в URL → русский интерфейс.
 */
import { bootKredafiFromUrl, bootLocaleFromPath } from "./utils/brand";

bootKredafiFromUrl();
bootLocaleFromPath();
